<template>
  <div class="cs" :class="{ 'cs--active': getSideMenuIsActive }">
    <div class="cs__inner">
      <div class="cs__header">
        <avl-sound-toggle class="cs__sound-toggle"></avl-sound-toggle>

        <avl-hamburger class="cs__hamburger"></avl-hamburger>
      </div>

      <!-- content -->
      <div class="cs__content">
        <ul class="cs__menu">
          <li
            class="cs__menu-item"
            v-for="item in menuItems"
            :key="item.name"
            :disabled="item.path.name === $route.name"
            @click="hideSideMenu"
          >
            <router-link :to="item.path">
              {{ item.label }}
            </router-link>
          </li>

          <li class="cs__menu-item">
            <a href="/pdfs/rules.pdf" target="_blank">Rules</a>
          </li>
        </ul>
      </div>

      <div class="cs__footer">
        <div class="cs__footer-head">
          <button class="cs__log-out-button" @click="onLogOut" v-if="isAuth">
            Log Out
          </button>

          <avl-paypal-donation />
        </div>

        <hr class="cs__separator" />

        <div class="cs__footer-row">
          <span>Reach us via </span>
          <a href="https://discord.gg/BQnKKdE" target="_blank">Discord,</a>
          <a href="https://www.reddit.com/r/avalon_fun/" target="_blank">Reddit,</a>
          <span>or</span>
          <a href="mailto:avalon.theresistance@gmail.com">Email</a>
        </div>

        <div class="cs__footer-row">
          <span>App developed by</span>
          <a href="https://www.linkedin.com/in/alex-lomia/" target="_blank">Alex</a>
          <span>and</span>
          <a href="https://www.linkedin.com/in/lasha-kitia-55095b81/" target="_blank">Lasha</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';

  export default {
    data: () => ({
      guestMenuItems: [
        { label: 'Home', path: { name: 'home' } },
        { label: 'Login', path: { name: 'userLogin' } },
        { label: 'Register', path: { name: 'userRegister' } },
      ],
      authMenuItems: [
        { label: 'Home', path: { name: 'home' } },
        { label: 'Lobby', path: { name: 'lobby' } },
        { label: 'Profile', path: { name: 'userProfile' } },
        { label: 'Change Password', path: { name: 'changePassword' } },
      ],
    }),
    computed: {
      ...mapGetters('layout', ['getSideMenuIsActive']),
      ...mapGetters('auth', ['isAuth']),
      menuItems() {
        return this.isAuth ? this.authMenuItems : this.guestMenuItems;
      },
    },
    methods: {
      ...mapActions('layout', ['hideSideMenu']),
      onLogOut() {
        this.$store.dispatch('auth/logOut');
        this.$store.dispatch('layout/hideSideMenu');
      },
    },
  };
</script>

<style scoped lang="scss">
  $width: 280px;
  $padding-x: 20px;

  .cs {
    position: fixed;
    top: 0;
    right: 0;
    height: 100%;
    background: #ffffff;
    transform-origin: top right;
    //
    transition: transform 250ms 100ms cubic-bezier(0, 0, 0, 1);
    transform: scaleX(0);
    box-shadow: -12px 0px 32px 0px rgba(0, 0, 0, 0.5);
    //
    width: $width;

    &--active {
      transition: transform 250ms;
      transform: scaleX(1);
    }

    &__inner {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      //
      transition: opacity 100ms;
      opacity: 0;
    }

    &__header {
      height: 100px;
      width: 100%;
    }

    &__sound-toggle {
      float: left;
    }

    &__hamburger {
      float: right;
    }

    &--active &__inner {
      transition: opacity 100ms 250ms;
      opacity: 1;
    }

    &__content {
      width: 100%;
      padding: $padding-x;
    }

    &__menu {
      list-style: none;
      padding: 0;
      margin: 0;
    }

    &__menu-item {
      display: block;
      font-size: 16px;

      &:hover {
        opacity: 0.8;
      }

      &[disabled] {
        opacity: 0.5;
      }

      a {
        color: #000000;
        display: inline-block;
        padding: 16px 0;
      }
    }

    &__footer {
      width: 100%;
      //
      position: absolute;
      bottom: 0;
      left: 0;
      padding: $padding-x;
    }

    &__footer-head {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    &__log-out-button {
      background: none;
      padding: 0;
      border: none;
      font-size: 16px;
      color: $red;

      &:hover {
        opacity: 0.8;
      }
    }

    &__separator {
      background: rgba(0, 0, 0, 0.3);
      color: rgba(0, 0, 0, 0.3);
      margin: 16px 0;
    }

    &__footer-row {
      display: inline-block;
      white-space: nowrap;
      font-family: Comfortaa, sans-serif;
      text-align: left;
      font-size: 1.4rem;
      font-weight: 300;
      margin-bottom: 16px;

      &:last-child {
        margin-bottom: 0;
      }

      & > * {
        display: inline-block;
        vertical-align: middle;
        margin: 0 2px;
        color: rgba(0, 0, 0, 0.3);

        &:first-child {
          margin-left: 0;
        }
      }

      a {
        text-decoration: underline;
      }
    }
  }
</style>
